import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link,useOutletContext } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import ProgressBar from "react-bootstrap/ProgressBar";
import { MaterialReactTable } from "material-react-table";
import { colors } from "@mui/material";
import ByCollection from "../components/ByCollection";
import ByCollectionMonthly from "../components/ByCollectionMonthly";

function InvoiceCollection() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const [optionsMonthly, setOptionsMonthly] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const [optionsLoaded, setOptionsLoaded] = useState(false);

  const columns = [
          {
          accessorKey: "year",
          header: "Year",
          size: 80,
          },
          {
          accessorKey: "total",
          header: "Total",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.total),
          },
          {
          accessorKey: "Q1",
          header: "Q1",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.Q1),
          },
          {
          accessorKey: "Q2",
          header: "Q2",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.Q2),
          },
          {
          accessorKey: "Q3",
          header: "Q3",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.Q3),
          },
          {
          accessorKey: "Q4",
          header: "Q4",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.Q4),
          }
      ];
  const columnsMonthly = [
          {
          accessorKey: "year",
          header: "Year",
          size: 80,
          },
          {
          accessorKey: "total",
          header: "Total",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.total),
          },
          {
          accessorKey: "April",
          header: "April",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.April),
          },
          {
          accessorKey: "May",
          header: "May",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.May),
          },
          {
          accessorKey: "June",
          header: "June",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.June),
          },
          {
          accessorKey: "July",
          header: "July",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.July),
          },
          {
          accessorKey: "August",
          header: "August",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.August),
          },
          {
          accessorKey: "September",
          header: "September",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.September),
          },
          {
          accessorKey: "October",
          header: "October",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.October),
          },
          {
          accessorKey: "November",
          header: "November",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.November),
          },
          {
          accessorKey: "December",
          header: "December",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.December),
          },
          {
          accessorKey: "January",
          header: "January",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.January),
          },
          {
          accessorKey: "February",
          header: "February",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.February),
          },
          {
          accessorKey: "March",
          header: "March",
          size: 100,
          Cell: ({ row }) => currency_converter_inr(row.original.March),
          },
      ];
      

    async function fetchOptions() {
        setGlobalLoading(true);
        try {
            const response = await axios.get(
            `${API_BASE_URL}/reports/get_revenue_collection/`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
            );
            setoptions(response.data.quarter_revenue_collection || []);
            setOptionsMonthly(response.data.monthly_revenue_collection || []);
            console.log(response.data.monthly_revenue_collection);
            const d = response.data;
            if (response.status == 200) {
                setData({
                ...d,
                });
            }
        } catch (error) {
            console.error("API Error:", error);
            setoptions([]);
        } finally {
            setGlobalLoading(false); 
            setOptionsLoaded(true);
        }
    }

    useEffect(() => {
    if (token) fetchOptions();
    }, [token]);
      
    return (
        <>
        <div className="card">
            <div className="card-body">
                <div className="border-bottom mb-3 pb-3">
                    <h4>Revenue Collection</h4>
                </div>
                <div className="row">
                    <div className="col-md-8 col-xl-8 col-xxl-8">
                        <div className="row align-items-center mb-3">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="custom-datatable-filter table-responsive">
                                    <MaterialReactTable
                                    columns={columns}
                                    data={options}
                                    initialState={{
                                        pagination: { pageSize: 200 },
                                    }}
                                    muiTableBodyRowProps={{
                                        sx: {
                                        height: "20px", // compact row height
                                        },
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                        padding: "2px 4px", // compact cell padding
                                        },
                                    }}
                                    muiTableHeadCellProps={{
                                        sx: {
                                        padding: "2px 4px", // same as body cells
                                        height: "30px", // or less
                                        },
                                    }}
                                    />
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-xl-4 col-xxl-4">
                        <div className="card-body my-card-body">
                            <div className="d-flex align-items-center justify-content-between">
                                <ByCollection chart_data={data?.quarter_revenue_collection} />
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="card">
                            <div className="card-body p-0">
                            <div className="custom-datatable-filter table-responsive">
                                <MaterialReactTable
                                columns={columnsMonthly}
                                data={optionsMonthly}
                                initialState={{
                                    pagination: { pageSize: 200 },
                                }}
                                muiTableBodyRowProps={{
                                    sx: {
                                    height: "20px", // compact row height
                                    },
                                }}
                                muiTableBodyCellProps={{
                                    sx: {
                                    padding: "2px 4px", // compact cell padding
                                    },
                                }}
                                muiTableHeadCellProps={{
                                    sx: {
                                    padding: "2px 4px", // same as body cells
                                    height: "30px", // or less
                                    },
                                }}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="card-body my-card-body">
                            <div className="d-flex align-items-center justify-content-between">
                                <ByCollectionMonthly chart_data={data?.monthly_revenue_collection} />
                            </div>
                        </div>
                    </div>
                </div>                                
            </div>
        </div>
        </>
    );
}

export default InvoiceCollection;